import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DataTableModel } from '@siren-survey/app/models/shared/cell-data-model';
import { MenuActionObject, MenuActionEmittedObject } from '@siren-survey/app/models/shared/datatable-objects.model';
import { TableAction } from '@siren-survey/app/models/shared/table-action';
import { TableFilterElement, TableFilterTypeEnum, FilterOperator, TableFilterOutput } from '@siren-survey/app/models/shared/table-filter.model';
import { LookupService } from '@siren-survey/app/services/lookups/lookup.service';
import { Subject } from 'rxjs';
import { ProgramList } from 'src/app/models/admin/program/program/programList';
import { ProgramService } from 'src/app/services/admin/program/program.service';
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { MarchPermissionEnum } from 'src/app/shared/enum/user-role.enum';

@Component({
  selector: 'app-program-table',
  templateUrl: './program-table.component.html',
  styleUrls: ['./program-table.component.sass']
})
export class ProgramTableComponent implements OnInit {
  tableTitleLabel: string;

  reloadEventSubject: Subject<boolean> = new Subject<boolean>();
  filterEventSubject: Subject<Map<string, any>> = new Subject<Map<string, any>>();
  initiateSearchFromFilter = true;
  canAdd: boolean = false;
  hasListAccess: boolean = false;
  predefinedFilter: Map<string, any>;
  marchPermissionEnum: typeof MarchPermissionEnum = MarchPermissionEnum;

  _booleanIconColumnDisplayList: string[] = [
    "isDeleted"
  ]

  _tableColumns  : DataTableModel<ProgramList> []= [
    {  columnDef: 'name', headerTranslationPath: "program.fields.name", header: 'Name',  cell: (element: ProgramList) => `${element.name}`, width: undefined,contentClass: 'leftAlign'},
    {  columnDef: 'goal', headerTranslationPath: "program.fields.goal", header: 'goal',  cell: (element: ProgramList) => `${element.goal}`, width: undefined,contentClass: 'leftAlign'},
    {  columnDef: 'organization', headerTranslationPath: "program.fields.organization", header: 'Organizations',  cell: (element: ProgramList) => `${element.organizationNames}`, width: '150px', contentClass: 'leftAlign'},
    {  columnDef: 'startDate', headerTranslationPath: "program.fields.start-date",  header: 'Start Date',  cell: (element: ProgramList) => `${element.startDate ? this.datePipe.transform(element.startDate, 'dd / MM / yyyy')  : "-"}`, width: '150px'},
    {  columnDef: 'endDate', headerTranslationPath: "program.fields.end-date",  header: 'End Date',  cell: (element: ProgramList) => `${element.endDate ? this.datePipe.transform(element.endDate, 'dd / MM / yyyy') : "-"}`, width: '150px'},
    {  columnDef: 'creationDateTime', headerTranslationPath: "program.fields.creation-date",  header: 'Creation Date',  cell: (element: ProgramList) => `${element.creationDateTime ? this.datePipe.transform(element.creationDateTime, 'dd / MM / yyyy') : "-"}`, width: '150px'},
    {  columnDef: 'isDeleted', headerTranslationPath: "program.fields.status", header: 'Status',  cell: (element: ProgramList) => `${!element.isDeleted}`, width: '100px'},
    {  columnDef: '_menu_inline', headerTranslationPath: "", header: '',  cell: undefined, width: '25px'}
  ] ;

  filters: TableFilterElement[] = [
    { name: "name", translationPath: "program.fields.name", displayName: this._translateService.instant('program.fields.name'), type: TableFilterTypeEnum.String, lookupName: undefined, lookupsValueById: undefined, value: undefined, valueFrom: undefined, valueTo: undefined, values: undefined, operator: FilterOperator.Like , cssClass: 'col-xs-12 col-sm-6 col-md-3' },
    { name: "programOrganizations.organization.id", translationPath: "program.fields.organization", displayName: this._translateService.instant('program.fields.name'), type: TableFilterTypeEnum.LookupObject, lookupName: "MarchOrganization", lookupsValueById: true, value: undefined, valueFrom: undefined, valueTo: undefined, values: undefined, operator: FilterOperator.Equal , cssClass: 'col-xs-12 col-sm-6 col-md-3'  },
    { name: "goal", translationPath: "program.fields.goal", displayName: this._translateService.instant('program.fields.name'), type: TableFilterTypeEnum.String, lookupName: undefined, lookupsValueById: undefined, value: undefined, valueFrom: undefined, valueTo: undefined, values: undefined, operator: FilterOperator.Like  , cssClass: 'col-xs-12 col-sm-6 col-md-3' },
    { name: "isDeleted", translationPath: "program.fields.isDeleted", displayName: this._translateService.instant('program.fields.deleted'), type: TableFilterTypeEnum.Boolean, lookupName: undefined, lookupsValueById: undefined, value: undefined, valueFrom: undefined, valueTo: undefined, values: undefined, operator: FilterOperator.Equal  , cssClass: 'col-xs-12 col-sm-6 col-md-3' },
    { name: "creationDateTime", translationPath: "program.fields.creation-date", displayName: this._translateService.instant('program.fields.name'), type: TableFilterTypeEnum.DateRange, lookupName: undefined, lookupsValueById: undefined, value: undefined, valueFrom: undefined, valueTo: undefined, values: undefined, operator: FilterOperator.Equal, cssClass: 'col-xs-12 col-sm-6 col-md-4'  },
    { name: "startDate", translationPath: "program.fields.start-date", displayName: this._translateService.instant('program.fields.start-date'), type: TableFilterTypeEnum.DateRange, lookupName: undefined, lookupsValueById: undefined, value: undefined, valueFrom: undefined, valueTo: undefined, values: undefined, operator: FilterOperator.Equal , cssClass: 'col-xs-12 col-sm-6 col-md-4' },
    { name: "endDate", translationPath: "program.fields.end-date", displayName: this._translateService.instant('program.fields.end-date'), type: TableFilterTypeEnum.DateRange, lookupName: undefined, lookupsValueById: undefined, value: undefined, valueFrom: undefined, valueTo: undefined, values: undefined, operator: FilterOperator.Equal, cssClass: 'col-xs-12 col-sm-6 col-md-4'  },
  ];

  _tableMenuAction: MenuActionObject[] = [
    { name: this._translateService.instant('global.disable'), actionName: "DISABLE_ACTION", fontAwesomeIcon:"", iconStyle: "width: 20px; height: 20px; margin-right: 5px; margin-left: 5px;", iconUrl: "", allowedAction: this.authService.userModuleAccessRightValidation(this.marchPermissionEnum.PROGRAM_MODIFY) , accessRightExpressions: new Map<string, string>([ ["id", "id > 0"], ["isDeleted", "isDeleted == false || isDeleted == null"] ])},
    { name: this._translateService.instant('global.enable'), actionName: "REACTIVATE_ACTION", fontAwesomeIcon:"fa fa-check", iconStyle: "width: 20px; height: 20px; margin-right: 5px; margin-left: 5px;", iconUrl: "../../../../assets/icons/delete-icon.svg", allowedAction: this.authService.userModuleAccessRightValidation(this.marchPermissionEnum.PROGRAM_MODIFY) , accessRightExpressions: new Map<string, string>([ ["id", "id > 0"], ["isDeleted", "isDeleted == true"] ])},
    { name: `${this._translateService.instant('activities.fields.view-assessment')}`, actionName: "EDIT_MODE", iconStyle: "width: 20px; height: 20px; margin-right: 5px; margin-left: 5px;", iconUrl: "assets/icons/generate-report-icon.svg", allowedAction: this.authService.userModuleAccessRightValidation(this.marchPermissionEnum.ASSESSMENTS_MODIFY) , accessRightExpressions: new Map<string, string>([ ["id", "id > 0"] ])},
    { name: `${this._translateService.instant('activities.fields.create-assessment')}`, actionName: "ADD_MODE", iconStyle: "width: 20px; height: 20px; margin-right: 5px; margin-left: 5px;", iconUrl: "assets/icons/duplicate-icon-black.svg", allowedAction: this.authService.userModuleAccessRightValidation(this.marchPermissionEnum.ASSESSMENTS_MODIFY) , accessRightExpressions: new Map<string, string>([ ["id", "id > 0"] ])},
  ]

  _sortingDataAccessor : (data: any, sortHeaderId: string) => string | number;
  _filteringPredicate : (data: any, filter: string) => boolean;

  getDeleteBtnLabel(): string{
    return this._translateService.instant('global.delete');
  }

  constructor(public service : ProgramService,
    private router: Router,
    private route : ActivatedRoute,
    private readonly _translateService: TranslateService,
    public lookupService: LookupService,
    public authService: AuthenticationService,
    private snackbar: MatSnackBar,
    private datePipe: DatePipe,
  ) {
    this.predefinedFilter = new Map<string, any>();
    this._sortingDataAccessor = (item: any, property: string) => {
      switch(property) {
        default: return item[property];
      }
    };

    this._filteringPredicate = (data: any, filter: string)  => {
      const accumulator = (currentTerm: any, key: any) => {
        return currentTerm + data[key];
      };
      const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };

    this.canAdd = (this.authService.userModuleAccessRightValidation(this.marchPermissionEnum.PROGRAM_GET) && this.authService.userModuleAccessRightValidation(this.marchPermissionEnum.PROGRAM_MODIFY));
    this.hasListAccess = this.authService.userModuleAccessRightValidation(this.marchPermissionEnum.PROGRAM_LIST);

  }

  ngOnInit(): void {
  }

  // this is used to route the table row onto its form page with the id attached
  updateViewMode(event: TableAction){
    if(event.mode == TableAction.EDIT_MODE && this.authService.userModuleAccessRightValidation(this.marchPermissionEnum.PROGRAM_GET)){
      this.router.navigate([event.id], {relativeTo: this.route});
    } else if(event.mode == TableAction.CREATE_MODE) {
      this.router.navigate(["create"], {relativeTo: this.route});
    }
  }

  applyFilter(event: TableFilterOutput){
    if(event){
      let filterMap: Map<string, any> = new Map();
      event.filterComponents.forEach(filter => {
        filterMap.set(filter.name, filter.value);
      });
      this.filterEventSubject.next(filterMap);
    }
  }


  tableMenuActionHandler(menuAction: MenuActionEmittedObject){
    if(menuAction && menuAction.actionName && menuAction.object){
      if(menuAction.actionName == "DISABLE_ACTION"){
        this.service.deleteObject(menuAction.object.id).subscribe( response =>{
          this.reloadEventSubject.next(true);
        }, error =>{
          let message = error && error.error && error.error.message.includes("ConstraintViolationException")
            ? this._translateService.instant('error.record-depending-error')
            : this._translateService.instant('error.record-error');
          this.snackbar.open(message, null, { duration: 3000 });
        });
      } else if(menuAction.actionName == "REACTIVATE_ACTION"){
        this.service.reactivateProgram(menuAction.object.id).subscribe( response =>{
          this.reloadEventSubject.next(true);
        }, error =>{
          let message = error && error.error && error.error.code && error.error.code == 'CONFLICT' && error.error.message ? error.error.message : "Unable to re-activate program";
          this.snackbar.open(message, null, { duration: 3000 });
        });
      } else if(menuAction.actionName == "ADD_MODE"){
        this.router.navigate([`../../enrollment/program/${menuAction.object.id}/assessment-result/${menuAction.actionName}/${menuAction.object.name}`], {relativeTo: this.route});
      } else if(menuAction.actionName == "EDIT_MODE"){
        this.router.navigate([`../../enrollment/program/${menuAction.object.id}/assessment-result/${menuAction.actionName}/${menuAction.object.name}`], {relativeTo: this.route});
      }
    }
  }
}
